import { joinClasses } from 'utils/joinClasses'
import { useMemo } from 'react'
import { Typography, LazyImage } from '@frontend/design_system'
import arrowDownIcon from 'assets/icons/yellow900/yellow900_arrowDown_16x16.webp'
import arrowUpIcon from 'assets/icons/green900/green900_arrowUp_16x16.webp'
import equalIcon from 'assets/icons/grey600/grey600_equal_16x16.webp'
import dotIcon from 'assets/icons/grey600/grey600_dot_16x16.webp'
import { BADGE_VARIANT, NOT_AVAILABLE } from './constants'
import styles from './styles.module.scss'

const colors = {
  [BADGE_VARIANT.GROWTH]: 'green900',
  [BADGE_VARIANT.DECLINE]: 'yellow900',
  [BADGE_VARIANT.NEUTRAL]: 'grey600',
  [BADGE_VARIANT.EMPTY]: 'grey600',
}

const icons = {
  [BADGE_VARIANT.GROWTH]: (
    <LazyImage src={arrowUpIcon} width={16} height={16} />
  ),
  [BADGE_VARIANT.DECLINE]: (
    <LazyImage src={arrowDownIcon} width={16} height={16} />
  ),
  [BADGE_VARIANT.NEUTRAL]: <LazyImage src={equalIcon} width={16} height={16} />,
  [BADGE_VARIANT.EMPTY]: <LazyImage src={dotIcon} width={16} height={16} />,
}

export const PercentBadge = ({ percent }: { percent?: number }) => {
  const variant = useMemo(() => {
    if (typeof percent === 'number') {
      if (percent > 0) return BADGE_VARIANT.GROWTH
      if (percent < 0) return BADGE_VARIANT.DECLINE
      return BADGE_VARIANT.NEUTRAL
    }
    return BADGE_VARIANT.EMPTY
  }, [percent])

  return (
    <Typography
      Tag="div"
      className={joinClasses(styles.badge, styles[variant])}
      color={colors[variant]}
      name="body2WRegular"
      dataTestId={`percent-badge-${variant}`}
    >
      {icons[variant]}
      {typeof percent === 'number' ? `${Math.round(percent)}%` : NOT_AVAILABLE}
    </Typography>
  )
}
